<div
  #subsection
  [ngClass]="{
    'gap-5': hasMultipleChildren,
    'text-[#F7FAFDDE]': isDarkMode(),
    'text-standard-text-primary border-standard-outline-light bg-white':
      !isDarkMode() && !isDisabled(),
    'text-gray-400': isDisabled(),
    'text-black': !isDisabled(),
  }"
  [ngStyle]="{
    borderColor: isDarkMode()
      ? darkModeColor()
      : corporateDesign()?.primaryBorderColor,
    backgroundColor: isDarkMode() ? darkModeColor() : '',
  }"
  [attr.data-testid]="'sub-section-' + testIdAffix()"
  class="text-standard-text-primary flex w-full flex-col">
  <div class="flex w-full items-center justify-between py-2">
    <div class="shrink-0">
      <ng-content select="aw-sub-section-headline"></ng-content>
    </div>

    <div class="flex items-center gap-3">
      <ng-content select="aw-sub-section-header-actions"></ng-content>

      @if (isCollapsible()) {
        <aw-button
          [id]="'extend-sub-section'"
          [type]="'button'"
          (click)="toggleCollapse()"
          [style]="'custom'"
          class="w-8">
          <span class="material-symbols-rounded">
            {{ isCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
          </span>
        </aw-button>
      }
    </div>
  </div>

  @if (!isCollapsed) {
    <div class="w-full pt-4">
      <ng-content></ng-content>
    </div>
  }
</div>
